import * as PIXI from 'pixi.js';
import { unzipSync } from "fflate";

export async function loadZipAssetPack(assetPath: string) {
	const res = await fetch(assetPath);
	const buf = new Uint8Array(await res.arrayBuffer());
	const files = unzipSync(buf);

	const map = new Map<string, Uint8Array>();
	for (const [name, data] of Object.entries(files)) {
		map.set(name, data);
	}
	return map;
}

export async function loadParticleAssets() {
	const particlePack = await loadZipAssetPack("assets/particles.zip");

	const particleAssets: { [key: string]: PIXI.Texture } = {};
	particleAssets['particle'] = await loadTextureFromPack(particlePack, 'particle.png');
	particleAssets['particle_blue'] = await loadTextureFromPack(particlePack, 'particle_blue.png');
	particleAssets['healParticle'] = await loadTextureFromPack(particlePack, 'heal_particle.png');
	particleAssets['kennyParticle'] = await loadTextureFromPack(particlePack, 'kenny_particle.png');
	particleAssets['coin'] = await loadTextureFromPack(particlePack, 'coin.png');
	particleAssets['bubbleParticle'] = await loadTextureFromPack(particlePack, 'bubble_particle.png');
	particleAssets['exclamationMark'] = await loadTextureFromPack(particlePack, 'exclamation-mark_1.png');
	particleAssets['questionMark'] = await loadTextureFromPack(particlePack, 'question-mark.png');
	particleAssets['bloodSplatter'] = await loadTextureFromPack(particlePack, 'blood_splatter.png');
	particleAssets['electricity1'] = await loadTextureFromPack(particlePack, 'electricity-1.png');
	particleAssets['electricity2'] = await loadTextureFromPack(particlePack, 'electricity-2.png');
	particleAssets['electricity3'] = await loadTextureFromPack(particlePack, 'electricity-3.png');
	console.log("ParticleFactory: loaded particle assets");

	return particleAssets;
}

export async function loadSpriteAssets() {
	const spritePack = await loadZipAssetPack("assets/sprites.zip");
	const spriteBaseTextureAssets: { [key: string]: PIXI.BaseTexture } = {};
	const spriteTextureAssets: { [key: string]: PIXI.Texture } = {};

	spriteTextureAssets['voronoi'] = await loadTextureFromPack(spritePack, 'voronoi-1-256.png');
	spriteTextureAssets['lensDirt'] = await loadTextureFromPack(spritePack, 'lens-dirt-map.png');

	spriteTextureAssets['displacementMap'] = await loadTextureFromPack(spritePack, 'displacement_map.png');
	spriteTextureAssets['target'] = await loadTextureFromPack(spritePack, 'target.png');
	spriteTextureAssets['heart'] = await loadTextureFromPack(spritePack, 'heart.png');
	spriteTextureAssets['spiky_speech_bubble'] = await loadTextureFromPack(spritePack, 'spiky_speech_bubble.png');
	spriteTextureAssets['blood_splatter'] = await loadTextureFromPack(spritePack, 'blood_splatter_with_alpha.png');
	//missing arial font

	spriteBaseTextureAssets['cellSpriteSheet'] = await loadBaseTextureFromPack(spritePack, 'cellSpriteSheet.png');
	spriteBaseTextureAssets['depthSpriteSheet'] = await loadBaseTextureFromPack(spritePack, 'depthSpriteSheet.png');
	spriteBaseTextureAssets['glowSpriteSheet'] = await loadBaseTextureFromPack(spritePack, 'glowSpriteSheet.png');
	spriteBaseTextureAssets['ciliaSpriteSheet'] = await loadBaseTextureFromPack(spritePack, 'ciliaSpriteSheet.png');
	spriteBaseTextureAssets['membraneDepthSpriteSheet'] = await loadBaseTextureFromPack(spritePack, 'membraneDepthSpriteSheet.png');

	//replace above

	console.log("ParticleFactory: loaded sprite assets");
	return { spriteBaseTextureAssets, spriteTextureAssets };
}

async function loadTextureFromPack(pack: Map<string, Uint8Array>, filename: string): Promise<PIXI.Texture> {
	const u8 = pack.get(filename);
	if (!u8) {
		throw new Error(`ParticleFactory: loadTextureFromPack: could not find ${filename} in particle pack`);
	}
	const blob = new Blob([u8.slice()], { type: 'image/png' });
	return PIXI.Texture.from(URL.createObjectURL(blob));
}

async function loadBaseTextureFromPack(pack: Map<string, Uint8Array>, filename: string): Promise<PIXI.BaseTexture> {
	const u8 = pack.get(filename);
	if (!u8) {
		throw new Error(`ParticleFactory: loadBaseTextureFromPack: could not find ${filename} in particle pack`);
	}
	const blob = new Blob([u8.slice()], { type: 'image/png' });
	return PIXI.BaseTexture.from(await loadImage(URL.createObjectURL(blob), filename));
}

export function loadImage(url: string, key: string) {
	return new Promise<HTMLImageElement>((resolve, reject) => {
		const img = new Image();
		img.addEventListener('load', e => resolve(img));
		img.addEventListener('error', () => {
			reject(new Error(`Failed to load image's URL: ${url}`));
		});
		img.src = url;
		img.id = "asset_" + key;
		return img;
	});
}